import { useQuery } from "@tanstack/react-query";

import { useAppState } from "Context/StateContext";
import { CompanyConfig } from "Models/company.config";
import { CompanyConfigsService } from "Services/company-configs.service";

export type QuickOrderFlags = {
  quickOrderEnabled: boolean;
  managementOrderReportEnabled: boolean;
};

const defaultQuickOrderFlags: QuickOrderFlags = {
  quickOrderEnabled: false,
  managementOrderReportEnabled: false,
};

export const getQuickOrderFlags = (
  companyConfig?: Partial<CompanyConfig> | null
): QuickOrderFlags => {
  const quickOrder = companyConfig?.settings?.opsAppConfiguration?.quickOrder;

  if (!quickOrder) {
    return defaultQuickOrderFlags;
  }

  const quickOrderEnabled = Boolean(quickOrder.enabled);

  return {
    quickOrderEnabled,
    managementOrderReportEnabled:
      quickOrderEnabled && Boolean(quickOrder.managementOrderReportEnabled),
  };
};

export const useQuickOrderFeature = () => {
  const { currentUser } = useAppState();

  const { data, isFetching, refetch } = useQuery(
    ["company-config.quick-order.flags", currentUser?.companyId],
    async () => {
      const response = await CompanyConfigsService.getCurrent();
      return response.data;
    },
    {
      enabled: !!currentUser?.companyId,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    }
  );

  const flags = getQuickOrderFlags(data);

  return {
    ...flags,
    isLoadingQuickOrderFlags: isFetching,
    companyConfig: data,
    refetchQuickOrderFlags: refetch,
  };
};
